!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("prop-types"), require("react"), require("vivus")) : "function" == typeof define && define.amd ? define(["prop-types", "react", "vivus"], t) : "object" == typeof exports ? exports.ReactVivus = t(require("prop-types"), require("react"), require("vivus")) : e.ReactVivus = t(e["prop-types"], e.react, e.vivus);
}(this, function (e, t, n) {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.i = function (e) {
      return e;
    }, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 3);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t) {
    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function u(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        f = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        c = n(1),
        l = r(c),
        s = n(0),
        p = r(s),
        d = n(2),
        y = r(d),
        b = {
      EASE: y.default.EASE,
      EASE_IN: y.default.EASE_IN,
      EASE_OUT: y.default.EASE_OUT,
      EASE_OUT_BOUNCE: y.default.EASE_OUT_BOUNCE
    },
        m = function (e) {
      function t() {
        return o(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return u(t, e), f(t, [{
        key: "componentDidMount",
        value: function value() {
          var e = this.props,
              t = e.id,
              n = e.option,
              r = e.callback,
              o = n;
          n.animTimingFunction && (o = a({}, o, {
            animTimingFunction: b[n.animTimingFunction]
          })), n.pathTimingFunction && (o = a({}, o, {
            pathTimingFunction: b[n.pathTimingFunction]
          })), new y.default(t, o, r);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.id,
              n = e.style,
              r = e.className;
          return l.default.createElement("div", {
            id: t,
            className: r,
            style: n
          });
        }
      }]), t;
    }(c.PureComponent);

    m.defaultProps = {
      className: "",
      style: {},
      callback: void 0
    }, m.propTypes = {
      id: p.default.string.isRequired,
      option: p.default.shape({
        type: p.default.string,
        file: p.default.string.isRequired,
        start: p.default.string,
        duration: p.default.number,
        delay: p.default.number,
        onReady: p.default.func,
        pathTimingFunction: p.default.string,
        animTimingFunction: p.default.string,
        dashGap: p.default.number,
        forceRender: p.default.bool,
        reverseStack: p.default.bool,
        selfDestroy: p.default.bool
      }).isRequired,
      className: p.default.string,
      style: p.default.shape({}),
      callback: p.default.func
    }, t.default = m;
  }]);
});